import IconTeamType1 from '@/assets/img/aboutpage/icons/icon-team-type-1.png';
import IconTeamType2 from '@/assets/img/aboutpage/icons/icon-team-type-2.png';
import IconTeamType3 from '@/assets/img/aboutpage/icons/icon-team-type-3.png';
import IconTeamType4 from '@/assets/img/aboutpage/icons/icon-team-type-4.png';
import IconTeamType5 from '@/assets/img/aboutpage/icons/icon-team-type-5.png';
import { TeamType } from './teamTypes';

const TEAM_TYPE_STYLES: Record<
  TeamType,
  { color: string; icon: string }
> = {
  [TeamType.Administration]: {
    color: '#d07d01',
    icon: IconTeamType1,
  },
  [TeamType.Frontend]: {
    color: '#30BBCE',
    icon: IconTeamType2,
  },
  [TeamType.Backend]: {
    color: '#387FD4',
    icon: IconTeamType3,
  },
  [TeamType.Marketing]: {
    color: '#983483',
    icon: IconTeamType4,
  },
  [TeamType.Sales]: {
    color: '#78a02b',
    icon: IconTeamType5,
  },
};

const DEFAULT_SUBTITLES: Record<TeamType, {de: string; en: string}> = {
  [TeamType.Administration]: {
    de: 'Geschäftsleitung',
    en: 'Administration',
  },
  [TeamType.Frontend]: {
    de: 'Frontend-Entwicklung',
    en: 'Frontend Development',
  },
  [TeamType.Backend]: {
    de: 'Backend-Entwicklung',
    en: 'Backend Development',
  },
  [TeamType.Marketing]: {
    de: 'Marketing',
    en: 'Marketing',
  },
  [TeamType.Sales]: {
    de: 'Customer Relations',
    en: 'Customer Relations',
  },
};

export type TeamLocale = 'de' | 'en';

export function getTypeStyle(type: TeamType): {
  color: string;
  icon: string;
} {
  return TEAM_TYPE_STYLES[type];
}

export function getDefaultSubtitle(
  type: TeamType,
  locale: TeamLocale,
): string {
  return DEFAULT_SUBTITLES[type][locale];
}

export interface TeamMemberWithOptionalSubtitle {
  type: TeamType;
  subtitleDe?: string;
  subtitleEn?: string;
}

/**
 * Resolves the current locale to 'de' or 'en' (i18n may use e.g. 'de-DE').
 */
function toTeamLocale(locale: string): TeamLocale {
  return locale.startsWith('de') ? 'de' : 'en';
}

export function getDisplaySubtitle(
  teamMember: TeamMemberWithOptionalSubtitle,
  locale: string,
): string {
  const loc = toTeamLocale(locale);
  const override = loc === 'de' ? teamMember.subtitleDe : teamMember.subtitleEn;
  if (override !== undefined && override !== '') {
    return override;
  }
  return getDefaultSubtitle(teamMember.type, loc);
}

export default TEAM_TYPE_STYLES;
